import { render, staticRenderFns } from "./LoadingOrders.vue?vue&type=template&id=87923d52"
import script from "./LoadingOrders.vue?vue&type=script&lang=js"
export * from "./LoadingOrders.vue?vue&type=script&lang=js"
import style0 from "./LoadingOrders.vue?vue&type=style&index=0&id=87923d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports